<div class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-white/[0.05] dark:bg-white/[0.03]">
  <div class="max-w-full overflow-x-auto">
    <table class="min-w-full">
      <!-- Table Header -->
      <thead class="border-b border-gray-100 dark:border-white/[0.05]">
        <tr>
          <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">User</th>
          <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Project Name</th>
          <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Team</th>
          <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Status</th>
          <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Budget</th>
        </tr>
      </thead>
      <!-- Table Body -->
      <tbody class="divide-y divide-gray-100 dark:divide-white/[0.05]">
        @for (order of tableData; track $index) {
        <tr>
          <td class="px-5 py-4 sm:px-6 text-start">
            <div class="flex items-center gap-3">
              <div class="w-10 h-10 overflow-hidden rounded-full">
                <img
                  width="40"
                  height="40"
                  [src]="order.user.image"
                  [alt]="order.user.name"
                />
              </div>
              <div>
                <span class="block font-medium text-gray-800 text-theme-sm dark:text-white/90">
                  {{ order.user.name }}
                </span>
                <span class="block text-gray-500 text-theme-xs dark:text-gray-400">
                  {{ order.user.role }}
                </span>
              </div>
            </div>
          </td>
          <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
            {{ order.projectName }}
          </td>
          <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
            <div class="flex -space-x-2">
              @for (teamImage of order.team.images; track $index; let i = $index) {
              <div class="w-6 h-6 overflow-hidden border-2 border-white rounded-full dark:border-gray-900">
                <img
                  width="24"
                  height="24"
                  [src]="teamImage"
                  [alt]="'Team member ' + (i + 1)"
                  class="w-full size-6"
                />
              </div>
              }
            </div>
          </td>
          <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
            <app-badge
              size="sm"
              [color]="getBadgeColor(order.status)"
            >
              {{ order.status }}
            </app-badge>
          </td>
          <td class="px-4 py-3 text-gray-500 text-theme-sm dark:text-gray-400">
            {{ order.budget }}
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>